import { Record } from 'immutable';
import { SET_IS_FETCHING_CHANNELS } from './actionTypes';

const StatusRecord = Record({
  isFetchingChannels: false,
});

export default function statusReducer(state = StatusRecord(), { type, payload } = {}) {
  if (type === SET_IS_FETCHING_CHANNELS) {
    return state.set('isFetchingChannels', payload);
  }
  return state;
}
